import React, { useState } from "react";
import { AddPagesGraph } from "../../../../../../../../core/Services";
import { Button, Input } from "@chakra-ui/react";
import { useToast } from "@chakra-ui/react";
import { Dropdown } from "primereact/dropdown";
import { Message } from "primereact/message";

export default function PagesGraphPage({
  uniqueCustomerId,
  selectedMonth,
  selectedCustomer,
  updateTableData,
  browser,
}) {
  const [pages, setPages] = useState("");
  const [platform, setPlatform] = useState("");
  const [visitor, setVisitor] = useState("");
  const [screening, setScreening] = useState("");
  const [validationError, setValidationError] = useState(false);

  const toast = useToast();

  const validateInputs = () => {
    if (
      !selectedCustomer ||
      !platform ||
      !visitor ||
      !screening ||
      !pages ||
      !selectedMonth
    ) {
      setValidationError(true);
      return false;
    }
    setValidationError(false);
    return true;
  };

  const AddCountry = async () => {
    if (!validateInputs()) return;

    try {
      const response = await AddPagesGraph(
        uniqueCustomerId,
        platform,
        pages,
        visitor,
        screening,
        selectedMonth
      );

      if (response.message === "Hata") {
        toast({
          title: "Hata",
          description: "Kullanıcya Ait Bu Ay Verisi Zaten Mevcut",
          status: "error",
          duration: 3000,
          position: "top-right",
          isClosable: true,
        });
      } else {
        setPlatform("");
        setPages("");
        setScreening("")
        setVisitor("");

        toast({
          title: "Başarılı",
          description: "Ülke başarıyla eklendi.",
          status: "success",
          duration: 5000,
          isClosable: true,
          position: "top-right",
        });
        updateTableData();
      }
    } catch (error) {
      console.error("Hata oluştu:", error);
      // Hata durumunda kullanıcıya bilgi vermek için bir toast veya başka bir bildirim yapılabilir.
    }
  };

  return (
    <div className="h-auto">
      <div>
        <div className="font-bold text-xl mt-4">Platform Seçiniz : </div>
        <div className="mt-2">
          <Dropdown
            value={platform}
            onChange={(e) => setPlatform(e.value)}
            options={browser}
            placeholder="Platform Seçiniz"
            style={{
              border:
                validationError && !platform
                  ? "1px solid red"
                  : "1px solid gray",
              width: "30rem",
            }}
          />
        </div>
      </div>
      <div>
        <div className="font-bold text-xl mt-4">
          Görüntüleme Sayısı Giriniz :
        </div>
        <div className="mt-2">
          <Input
            filter
            onChange={(e) => {
              setScreening(e.target.value);
            }}
            value={screening}
            placeholder="Görüntüleme Sayısı"
            style={{
              border:
                validationError && !screening
                  ? "1px solid red"
                  : "1px solid gray",
              width: "30rem",
            }}
          />
        </div>
      </div>
      <div className="font-bold text-xl mt-4">Sayfa Giriniz :</div>
      <div className="mt-2">
        <Input
          filter
          onChange={(e) => {
            setPages(e.target.value);
          }}
          value={pages}
          placeholder="Sayfa Giriniz"
          style={{
            border:
              validationError && !pages ? "1px solid red" : "1px solid gray",
            width: "30rem",
          }}
        />
      </div>
      <div>
        <div className="font-bold text-xl mt-4">Kullanıcı Sayısı Giriniz :</div>
        <div className="mt-2">
          <Input
            filter
            onChange={(e) => {
              setVisitor(e.target.value);
            }}
            value={visitor}
            placeholder="Tıklama Sayısı"
            style={{
              border:
                validationError && !visitor
                  ? "1px solid red"
                  : "1px solid gray",
              width: "30rem",
            }}
          />
        </div>
      </div>
      {validationError && (
        <div className="text-red-500 mt-2 text-sm">
          Lütfen boş alanları doldurunuz.
        </div>
      )}
      <div className="mt-3 flex justify-content-end">
        <Button width="8rem" onClick={AddCountry}>
          Kaydet
        </Button>
      </div>

      <Message
        className="mt-2 w-full"
        severity="info"
        text="Google Analytics > Raporlar > Yaşam Döngüsü > Etkileşim > Sayfalar ve Ekranlar"
      />
    </div>
  );
}
